import { Close } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import './styles.css';

type PropTypes = {
  handleCreateBracketGameSubmit: (matchKey: string) => void;
  openCreateBracketGameDialog: boolean;
  setOpenCreateBracketGameDialog: (open: boolean) => void;
};

export const CreateBracketGameDialog = ({
  handleCreateBracketGameSubmit,
  openCreateBracketGameDialog,
  setOpenCreateBracketGameDialog,
}: PropTypes) => {
  const [matchKey, setMatchKey] = useState('00');

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleToggleChange = (event: any, matchKey: string) => {
    if (matchKey !== null) {
      setMatchKey(matchKey);
    }
  };

  const dialogTitleText = 'Create Bracket Game';
  const closeButton = (
    <IconButton onClick={() => setOpenCreateBracketGameDialog(false)}>
      <Close />
    </IconButton>
  );

  return (
    <Dialog
      fullScreen={fullScreen}
      open={openCreateBracketGameDialog}
      onClose={() => setOpenCreateBracketGameDialog(false)}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle
        id="responsive-dialog-title"
        className="diaolog-title-with-close-button"
      >
        {dialogTitleText}
        {closeButton}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={4}>
          <Stack direction="row" spacing={2}>
            <ToggleButtonGroup
              color="primary"
              value={matchKey}
              exclusive
              onChange={handleToggleChange}
              aria-label="Platform"
            >
              <ToggleButton value="00">00</ToggleButton>
              <ToggleButton value="01">01</ToggleButton>
              <ToggleButton value="02">02</ToggleButton>
              <ToggleButton value="03">03</ToggleButton>
              <ToggleButton value="10">10</ToggleButton>
              <ToggleButton value="11">11</ToggleButton>
              <ToggleButton value="20">20</ToggleButton>
            </ToggleButtonGroup>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ margin: 3 }}>
        <Button
          variant="text"
          onClick={() => setOpenCreateBracketGameDialog(false)}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleCreateBracketGameSubmit(matchKey)}
        >
          Create Game
        </Button>
      </DialogActions>
    </Dialog>
  );
};
